import styled from 'styled-components'
import { EyeOutline } from 'styled-icons/evaicons-outline'
import { BorderColor, QueryBuilder } from 'styled-icons/material-outlined'
import { Link } from 'react-router-dom'
import { BlueLight } from '../../constants/constants'

export const Container = styled.div`
  margin-top: 12px;
`

export const ActionLink = styled(Link)`
  color: #bdbdbd;
  cursor: 'pointer';
  align-self: end;
  margin-right: 12px;
`

export const ViewIcon = styled(EyeOutline)`
  color: #bdbdbd;
  color: ${({ $isActive }) => ($isActive ? BlueLight : '#BDBDBD')};
  &:hover {
    color: ${BlueLight};
  }
`
export const EditIcon = styled(BorderColor)`
  color: #bdbdbd;
  color: ${({ $isActive }) => ($isActive ? BlueLight : '#BDBDBD')};
  &:hover {
    color: ${BlueLight};
  }
`

export const AuditIcon = styled(QueryBuilder)`
  color: #bdbdbd;
  color: ${({ $isActive }) => ($isActive ? BlueLight : '#BDBDBD')};
  &:hover {
    color: ${BlueLight};
  }
`
